// src/redux/packageSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedPackage: null,
  // isConfirmBooked: false,
};

const packageSlice = createSlice({
  name: "package",
  initialState,
  reducers: {
    setSelectedPackage: (state, action) => {
      state.selectedPackage = action.payload;
    },
    clearSelectedPackage: (state) => {
      state.selectedPackage = null;
    },
    // setIsConfirmBooked:(state,action)=>{
    //   state.isConfirmBooked=action.payload;
    // }

  },
});

export const { setSelectedPackage, clearSelectedPackage } = packageSlice.actions;
export default packageSlice.reducer;
